/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_wf_results_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Most frequent words`)
};

const es_wf_results_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Palabras más frecuentes`)
};

const de_wf_results_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Häufigste Wörter`)
};

const nl_wf_results_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meest voorkomende woorden`)
};

const fr_wf_results_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mots les plus fréquents`)
};

const it_wf_results_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parole più frequenti`)
};

const pt_br2_wf_results_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Palavras mais frequentes`)
};

const pt_wf_results_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Palavras mais frequentes`)
};

const ja_wf_results_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最も頻繁に出現する単語`)
};

const zh_wf_results_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最高频单词`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const wf_results_label = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.wf_results_label(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("wf_results_label", locale)
	if (locale === "en") return en_wf_results_label(inputs)
	if (locale === "es") return es_wf_results_label(inputs)
	if (locale === "de") return de_wf_results_label(inputs)
	if (locale === "nl") return nl_wf_results_label(inputs)
	if (locale === "fr") return fr_wf_results_label(inputs)
	if (locale === "it") return it_wf_results_label(inputs)
	if (locale === "pt-BR") return pt_br2_wf_results_label(inputs)
	if (locale === "pt") return pt_wf_results_label(inputs)
	if (locale === "ja") return ja_wf_results_label(inputs)
	return zh_wf_results_label(inputs)
};